import { css, type Theme } from "@emotion/react";

import { SLIDE_SCRIM_COLOR, slideContentInset } from "../../SideCarouselPanel.styles";

export const slide = (theme: Theme) => css`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  ${slideContentInset(theme)};
`;

export const background = css`
  position: absolute;
  inset: 0;
  overflow: hidden;

  &::after {
    content: "";
    position: absolute;
    inset: 0;
    background-color: ${SLIDE_SCRIM_COLOR};
  }
`;

export const backgroundVideo = css`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const content = css`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 28px;
  width: 100%;
  max-width: 430px;
`;

export const textStack = (theme: Theme) => css`
  display: flex;
  flex-direction: column;
  align-self: stretch;
  gap: ${theme.ds5.spacing.gap.small};
`;

export const qrTile = (theme: Theme) => css`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 184px;
  height: 180px;
  padding: ${theme.ds5.spacing.gap.small};
  border-radius: 12px;
  background-color: ${theme.ds5.neutral.backgroundLevel0};
`;

export const qrImage = css`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;
